import { DateOnly } from '@if/core/date'
import { t } from '@if/core/i18n'
import * as yup from '@if/core/yup'

export const createStatisticsFilterSchema = (minFromDate: DateOnly) => {
  const today = DateOnly.today()
  return yup.object({
    merchantId: yup.text().required().default(''),
    fromDate: yup.dateOnly().required().min(minFromDate).max(today).default(today),
    toDate: yup
      .dateOnly()
      .required()
      .min(yup.ref('fromDate'), { offsetDays: 1, message: t('merchantStatistics.merchantLoanActivity.dateError') })
      .max(today)
      .default(today),
  })
}

export type StatisticsFilterFormValues = yup.InferSubmit<ReturnType<typeof createStatisticsFilterSchema>>
